import gsap from "gsap";

export function messageAnimation3() {
  let currentAnimation = null;

  // **初回アニメーション実行**
  setupAnimation();

  // **リサイズ時にアニメーションをリセット & 再適用**
  window.addEventListener("resize", () => {
    resetAnimation();
    setupAnimation();
  });

  function resetAnimation() {
    if (currentAnimation) {
      currentAnimation.kill();
      currentAnimation = null;
    }
    // **要素の位置・スタイルを完全リセット**
    gsap.set(".parts-member3", { x: 0, y: 0, rotation: 0, clearProps: "all" });
  }

  function setupAnimation() {
    resetAnimation();

    const isPC = window.matchMedia("(min-width: 750px)").matches;
    const members = [...document.querySelectorAll(".parts-member3")]; // **全メンバーを配列で取得**

    if (members.length === 0) return;

    currentAnimation = isPC ? animateMembersPC(members) : animateMembersSP(members);
  }

  // **PC用アニメーション**
  function animateMembersPC(members) {
    const containerWidth = document.querySelector(".message-animation").offsetWidth;
    const partWidth = members[0].offsetWidth;

    const tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });

    // **初期位置を一括適用**
    tl.set(members, { x: 0, y: 0, rotation: 0 });

    // **個別設定**
    const animations = [
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
      { duration: 7, rotation: "-=1440", delay: 0.5 },
    ];

    members.forEach((member, index) => {
      const { duration, rotation, delay } = animations[index] || animations[0];
      tl.to(
        member,
        {
          x: -containerWidth - partWidth,
          duration: duration,
          rotation: rotation,
          ease: "linear",
        },
        `<+=${delay}`
      );
    });

    return tl;
  }

  // **SP用アニメーション**
  function animateMembersSP(members) {
    const containerWidth = document.querySelector(".message-animation").offsetWidth;
    const partWidth = members[0].offsetWidth;

    const tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });

    // **初期位置を一括適用**
    tl.set(members, { x: 0, y: 0, rotation: 0 });

    // **個別設定**
    const animations = [
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.7 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.7 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 1.0 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.9 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.5 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
      { duration: 5, rotation: "-=720", delay: 0.8 },
    ];

    members.forEach((member, index) => {
      const { duration, rotation, delay } = animations[index] || animations[0];
      tl.to(
        member,
        {
          x: -containerWidth - partWidth,
          duration: duration,
          rotation: rotation,
          ease: "linear",
        },
        `<+=${delay}`
      );
    });

    return tl;
  }
}
